export default class PrivzetaVrednostLogic {
  static instance = null
  seznamPrivzetihVrednosti = {}

  /**
   * @returns {PrivzetaVrednostLogic}
   */
  static getInstance () {
    if (this.instance === null) {
      this.instance = new this()
    }
    return this.instance
  }

  GetPrivzetaVrednost (tip) {
    return this.seznamPrivzetihVrednosti['defaultVal' + tip]
  }

  ShraniPrivzetoVrednost (tip, vrednost) {
    this.seznamPrivzetihVrednosti['defaultVal' + tip] = vrednost
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/PrivzetaVrednostLogic.js